module.exports = __webpack_public_path__ + "88db9ff7385cadf0cbe04e7c4a85e749.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/excellent.svg
// module id = 393
// module chunks = 0